var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box, styled, Typography } from '@mui/material';
import React from 'react';
import { CheckCircleIcon, ExclamationStopIcon, InfoCircleIcon, WarningIcon } from '../../assets';
import { alertBackgroundColorMap, alertBorderColorMap, alertColorMap } from '../../constants';
const KariusAlert = React.forwardRef((_a, ref) => {
    var { children, variant = 'success', mode = 'toast', subtitle } = _a, otherProps = __rest(_a, ["children", "variant", "mode", "subtitle"]);
    const Alert = variant !== 'grey' ? StyledAlertIcon : StyledAlert;
    return (React.createElement(Alert, Object.assign({ sx: {
            border: '1px solid',
            borderLeft: `4px solid`,
            borderColor: mode === 'inline' ? alertBorderColorMap[variant] : alertBackgroundColorMap[variant],
            borderLeftColor: alertColorMap[variant],
            backgroundColor: alertBackgroundColorMap[variant],
            '& svg, .alert-text, .subtitle': { color: alertColorMap[variant] },
            '& .alert-text': {
                fontWeight: subtitle ? '700' : undefined,
            },
            boxShadow: mode === 'toast' ? '0px 2px 4px rgba(0, 0, 0, 0.25)' : undefined,
        }, ref: ref }, otherProps),
        {
            error: React.createElement(ExclamationStopIcon, { className: 'alert-icon', height: '14px', width: '14px' }),
            success: React.createElement(CheckCircleIcon, { className: 'alert-icon', height: '16px', width: '16px' }),
            warning: React.createElement(WarningIcon, { className: 'alert-icon', height: '15px', width: '18px' }),
            info: React.createElement(InfoCircleIcon, { className: 'alert-icon', height: '16px', width: '16px' }),
            grey: null,
        }[variant],
        React.createElement(Typography, { variant: 'body_01', className: 'alert-text' }, children),
        subtitle && (React.createElement(Typography, { variant: 'caption', className: 'subtitle' }, subtitle))));
});
export default KariusAlert;
const BaseStyledAlert = styled(Box)(({ theme }) => ({
    borderRadius: '3.5px',
    paddingLeft: `calc(${theme.spacing(3)} - 4px)`,
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    svg: {
        justifySelf: 'center',
    },
    '& .subtitle': {
        whiteSpace: 'pre-line',
    },
}));
const StyledAlertIcon = styled(BaseStyledAlert)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '20px auto',
    gridTemplateRows: '24px',
    columnGap: theme.spacing(2),
    alignItems: 'center',
    '& .subtitle': {
        gridColumn: 2,
    },
}));
const StyledAlert = styled(BaseStyledAlert)(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
}));
